import { Box, BoxProps } from '@mui/material';
import { keyframes, styled } from '@mui/material/styles';

interface LoaderProps extends BoxProps {
  hexColourCode?: string;
}

const defaultColour = '#000000';
const LoaderDimension = 4;
const LoaderGap = 6;

const dotFlashing = (hexColourCode: string) => {
  return keyframes`
    0% {
      background-color: ${hexColourCode ?? defaultColour};
    }
    50%, 100% {
      background-color: ${hexColourCode ? hexColourCode + '40' : defaultColour + '40'};
    }
  `;
};

const Wrapper = styled(Box)`
  width: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding-top: 1px;
`;

const StyledBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'hexColourCode',
})<{
  hexColourCode?: string;
}>`
  position: relative;
  width: ${LoaderDimension}px;
  height: ${LoaderDimension}px;
  border-radius: 5px;
  background-color: ${(props) => props.hexColourCode ?? defaultColour};
  color: ${(props) => props.hexColourCode ?? defaultColour};
  animation: ${(props) => dotFlashing(props.hexColourCode ?? defaultColour)} 1s infinite linear
    alternate;
  animation-delay: 0.5s;

  &::before,
  &::after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 0;
  }

  &::before {
    left: -${LoaderGap}px;
    width: ${LoaderDimension}px;
    height: ${LoaderDimension}px;
    border-radius: 5px;
    background-color: ${(props) => props.hexColourCode ?? defaultColour};
    color: ${(props) => props.hexColourCode ?? defaultColour};
    animation: ${(props) => dotFlashing(props.hexColourCode ?? defaultColour)} 1s infinite alternate;
    animation-delay: 0s;
  }

  &::after {
    left: ${LoaderGap}px;
    width: ${LoaderDimension}px;
    height: ${LoaderDimension}px;
    border-radius: 5px;
    background-color: ${(props) => props.hexColourCode ?? defaultColour};
    color: ${(props) => props.hexColourCode ?? defaultColour};
    animation: ${(props) => dotFlashing(props.hexColourCode ?? defaultColour)} 1s infinite alternate;
    animation-delay: 1s;
  }
`;

function Loader({ hexColourCode, ...rest }: LoaderProps) {
  return (
    <Wrapper {...rest}>
      <StyledBox hexColourCode={hexColourCode}></StyledBox>
    </Wrapper>
  );
}

export default Loader;
